
import { selectedLocale } from '@/core/plugins/i18n';
import i18n from '@/core/plugins/i18n';
import Vue from 'vue';
import Component from 'vue-class-component';
import { CurrencyFindAll } from '@/settings/application/uses_cases/currency/search/CurrencyFindAll';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { CountryFindAll } from '@/settings/application/uses_cases/country/search/CountryFindAll';
import { CurrencyFactorFindAll } from '@/settings/application/uses_cases/currencyfactor/search/CurrencyFactorFindAll';
import { CreateCurrencyFactor } from '@/settings/application/uses_cases/currencyfactor/create/CreateCurrencyFactor';
import { CurrencyFactorUpdate } from '@/settings/application/uses_cases/currencyfactor/update/CurrencyFactorUpdate';
import { CreateCurrency } from '@/settings/application/uses_cases/currency/create/CreateCurrency';
import { CurrencyFindById } from '@/settings/application/uses_cases/currency/search/CurrencyFindById';
import { CurrencyFactorFindByCurrencyCode } from '@/settings/application/uses_cases/currencyfactor/search/CurrencyFactorFindByCurrencyCode';
import FilterCustomize from '@/core/components/shared/FilterCustomize.vue';
import CustomTable from '@/core/components/shared/CustomTable.vue';
import { showAlert } from '@/core/plugins/Notifications';

@Component({
  name: 'RegisterCurrency',
  components: { FilterCustomize, CustomTable }
})
export default class RegisterCurrency extends Vue {
  @Inject(TYPES.FINDALL_CURRENCY)
  readonly currencyFindAllcall!: CurrencyFindAll;
  @Inject(TYPES.CREATE_CURRENCY)
  readonly currencySave!: CreateCurrency;
  @Inject(TYPES.FINDBYID_CURRENCY)
  readonly currencyFindById!: CurrencyFindById;
  @Inject(TYPES.FINDALL_CURRENCYFACTOR)
  readonly currencyFactorFindAllcall!: CurrencyFactorFindAll;
  @Inject(TYPES.CREATE_CURRENCYFACTOR)
  readonly currencyFactorSave!: CreateCurrencyFactor;
  @Inject(TYPES.UPDATE_CURRENCYFACTOR)
  readonly currencyFactorUpdate!: CurrencyFactorUpdate;
  @Inject(TYPES.FINDBYCURRENCYCODE_CURRENCYFACTOR)
  readonly currencyFactorFindByCurrencyCode!: CurrencyFactorFindByCurrencyCode;
  // currencyFactorFindByCurrency
  @Inject(TYPES.FINDALL_COUNTRY)
  readonly countryFindAllcall!: CountryFindAll;
  //DATA
  dataDummy = {
    profit: [0, 0, 0, 0, 0, 0, 0],
    income: [0, 0, 0, 0, 0, 0, 0],
    bill: [0, 0, 0, 0, 0, 0, 0],
    days: [1, 3, 5, 7, 9, 13, 16]
  };

  target = i18n.t('general.currency');
  isLoading = false;
  fullPage = true;
  countries = [];
  factorcurrencies = [] as any;
  factorcurrenciesTrm = [] as any;
  nameCurrencies = [] as any;
  isTouched = false;
  isDisable = false;
  isSave = true;
  totalRows = 1;
  currentPage = 1;
  perPage = 5;
  filter = null;
  filterOn = [];
  sortBy = 'currency';
  sortDesc = true;
  selectedLocales = selectedLocale;
  paramsFilter = false;
  filterDate = {
    from: '',
    to: ''
  };
  form: any = {
    currencyCode: [],
    currencyDescription: '',
    currencyCountry: [],
    currencyTrm: '',
    currencyDate: ''
  };
  dateNow: any = new Date();
  //REFS
  $refs!: {
    currencyDescription: HTMLInputElement;
  };
  //HOOKS
  created() {
    this.countryFindAll();
    this.$nextTick(() => this.currencyFindAll());
    this.$nextTick(() => this.currencyFactorFindAll());
    this.dateNow = new Date(this.dateNow.getTime() - this.dateNow.getTimezoneOffset() * 60000)
      .toISOString()
      .substring(0, 10);
    this.form.currencyDate = this.dateNow;
  }
  //COMPUTED
  get rows() {
    return this.currencyFactorUnified.length;
  }
  get fields() {
    return [
      { key: 'currency', label: this.translateCol('code'), sortable: true },
      { key: 'description', label: this.translateCol('description'), sortable: true },
      { key: 'country', label: this.translateCol('country'), sortable: true, sortDirection: 'desc' },
      { key: 'rate', label: this.translateCol('trm'), sortable: true },
      { key: 'date', label: this.translateCol('date'), sortable: true },
      { key: 'action', label: this.translateCol('action'), sortable: false }
    ];
  }
  get fieldsTrmList() {
    return [
      { key: 'rate', label: this.translateCol('trm'), sortable: true },
      { key: 'date', label: this.translateCol('date'), sortable: true }
    ];
  }
  get currencyFactorUnified() {
    const currencyFactors: any = [];
    for (const currencyAll of this.nameCurrencies) {
      for (const currencyFactorAll of this.factorcurrencies) {
        if (currencyAll['currencyCode'] === currencyFactorAll['currency']) {
          currencyFactorAll['description'] = currencyAll['description'];
          currencyFactorAll['countryName'] = currencyAll['countryName'];
          currencyFactors.push(currencyFactorAll);
        }
      }
    }
    return currencyFactors.reverse();
  }
  currencyFindAll() {
    this.isLoading = true;
    this.currencyFindAllcall
      .execute()
      .then((response: any) => {
        this.isLoading = false;
        if (response.code == 404) {
          this.nameCurrencies = [];
        } else {
          this.nameCurrencies = response;
        }
      })
      .catch(error => {
        this.isLoading = false;
        this.nameCurrencies = [];
        throw new Error(error);
      });
  }

  get currencyFactorTrmMap() {
    const res = this.factorcurrenciesTrm.map((item: any) => {
      return item.rate;
    });
    return res;
  }

  get currencyFactorTrmLabels() {
    const res = this.factorcurrenciesTrm.map((item: any) => {
      return item.date;
    });
    return res;
  }

  async countryFindAll() {
    this.isLoading = true;
    await this.countryFindAllcall
      .execute()
      .then((response: any) => {
        this.isLoading = false;
        this.countries = response;
      })
      .catch(error => {
        this.isLoading = false;
        this.countries = [];
        throw new Error(error);
      });
  }

  currencyFactorFindAll() {
    this.isLoading = true;
    this.currencyFactorFindAllcall
      .execute()
      .then((response: any) => {
        const responseFiltered: any[] = [];
        this.isLoading = false;
        response
          .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())
          .map((item: any) => {
            if (item.date <= this.dateNow) responseFiltered.push([item['currency'], item]);
          });
        new Map(responseFiltered).values();
        this.factorcurrencies = [...new Map(responseFiltered).values()];
      })

      .catch(error => {
        this.isLoading = false;
        this.factorcurrencies = [];
        throw new Error(error);
      });
  }

  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }
  onTouch() {
    this.isTouched = true;
  }
  translateCol(colName: string) {
    return this.$i18n.t('general.' + colName);
  }
  onFiltered(filteredItems: any) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  addTagCurrency(newTag: string) {
    this.form.currencyCode = { currencyCode: newTag, description: '' };
    this.isDisable = false;
    this.form.currencyDescription = '';
    this.$refs.currencyDescription.focus();
  }

  descriptionCurrency() {
    if (this.form.currencyCode.description != '' || this.form.currencyCode.description != null) {
      this.form.currencyDescription = this.form.currencyCode.description;
      this.form.currencyCountry = {
        code: this.form.currencyCode.countryCode,
        name: this.form.currencyCode.countryName
      };
      //Se verifica si la moneda que a agregar ya existe.
      const currencyExist = this.factorcurrencies.find(
        (element: any) => element.currency === this.form.currencyCode.currencyCode
      )
        ? true
        : false;

      if (currencyExist && this.isSave) {
        showAlert('error', `${this.$t('general.currency')} ${this.$t('generalmessage.ERROR_MESSAGE_WHEN_SAVING')}`);
        this.clearForm();
        return;
      }
      this.isDisable = true;
      this.isSave = true;
      return this.form.currencyDescription;
    } else {
      this.isSave = false;
      this.form.currencyDescription = '';
    }
  }

  setListTypeSave() {
    this.clearForm();
    this.isDisable = false;
    this.isSave = true;
  }

  cleanDateFilter() {
    this.filterDate = {
      from: '',
      to: ''
    };
  }

  //SAVE OR UPDATE CURRENCY
  handleSubmit(e: any) {
    e.preventDefault();
    //Verifica si se creó un TRM el dia de hoy

    const payloadCurrencyFactor: any = {
      currency: this.form.currencyCode.currencyCode,
      date: this.form.currencyDate,
      rate: this.form.currencyTrm.toString().trim()
    };
    const payloadCurrency: any = {
      currencyCode: this.form.currencyCode.currencyCode,
      description: this.form.currencyDescription.trim(),
      countryCode: this.form.currencyCountry.code
    };

    const currencyRateUpToDay = this.factorcurrenciesTrm.find(
      (element: any) => element.date === payloadCurrencyFactor.date
    )
      ? true
      : false;

    //Verifica si la fecha es mayor a 1 dia con respecto a la fecha actual
    if (this.limitDate(payloadCurrencyFactor.date)) {
      showAlert('warning', `${this.$t('generalmessage.ERROR_MESSAGE_WHEN_SAVING_LATER_DATE')}`);
      return;
    } else if (payloadCurrencyFactor.date < this.dateNow) {
      showAlert('warning', `${this.$t('generalmessage.ERROR_MESSAGE_WHEN_UPDATING_EARLIER_DATE')}`);
      return;
    }

    if (!this.isSave) {
      if (currencyRateUpToDay) {
        //Se actualiza
        this.currencyFactorUpdate
          .execute(payloadCurrencyFactor)
          .then((response: any) => {
            this.currencyFindAll();
            this.currencyFactorFindAll();
            this.currencyFactorUnified;
            this.isLoading = false;
            this.$bvModal.hide('mdRegisterCurrency');
            return response;
          })
          .catch((error: any) => {
            this.isLoading = false;
            throw new Error(error);
          });
        return;
      }
    }

    //Se ejecutan los métodos de guardado
    const promisesCurrency = [
      this.currencySave.execute(payloadCurrency),
      this.currencyFactorSave.execute(payloadCurrencyFactor)
    ];
    this.isLoading = true;
    Promise.all(promisesCurrency)
      .then(response => {
        this.isLoading = false;
        this.clearForm();
        this.currencyFindAll();
        this.currencyFactorFindAll();
        this.$bvModal.hide('mdRegisterCurrency');
        return response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }
  //EDIT-UPDATE
  async currencyfactorFindId(currency: any, date: string) {
    this.isSave = false;
    const promiseCurrencyFactorAll = [
      await this.currencyFindById.execute(currency),
      await this.currencyFactorFindByCurrencyCode.execute(currency)
    ];
    this.isLoading = true;
    Promise.all(promiseCurrencyFactorAll)
      .then((response: any) => {
        this.isLoading = false;
        const currencyCode: any = response[0]['currencyCode'];
        const dataCurrencyFactor: any = response[1];
        for (const factor of dataCurrencyFactor) {
          this.factorcurrenciesTrm = response[1];
          const dateCurrencyFactor: any = factor.date;
          if (currencyCode === currency && dateCurrencyFactor === date) {
            this.form.currencyCode = { currencyCode: response[0]['currencyCode'] };
            this.form.currencyDescription = response[0]['description'];
            this.form.currencyCountry = {
              name: response[0]['countryName'],
              code: response[0]['countryCode']
            };
            this.form.currencyDate = factor.date.substring(0, 10);
            this.form.currencyTrm = factor.rate;
            this.isSave = false;
            this.isDisable = true;
          }
        }
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  async currencyFindCode(code: any) {
    if (code) {
      this.isLoading = true;
      await this.currencyFindById
        .execute(code)
        .then((response: any) => {
          this.isLoading = false;
          if ('currencyCode' in response) {
            this.nameCurrencies = [];
            this.nameCurrencies.push(response);
            this.currencyFactorFindByCurrencyCode.execute(code).then((res: any) => {
              this.factorcurrencies = [];
              this.factorcurrencies.push(res[0]);
              this.paramsFilter = true;
              this.currencyFactorUnified;
            });
          } else {
            this.paramsFilter = false;
            showAlert('info', i18n.t('generalmessage.ERROR_MESSAGE_WHEN_SEARCHING_DATA'));
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    } else {
      this.paramsFilter = false;
      this.currencyFindAll();
      this.currencyFactorFindAll();
    }
  }
  clearForm() {
    const date = new Date();
    const isoDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
    this.form = {
      currencyCode: [],
      currencyDescription: '',
      currencyCountry: [],
      currencyTrm: '',
      currencyDate: isoDateTime.substring(0, 10)
    };
  }

  limitDate(formDate: any) {
    const payloadDate = formDate.split('-');
    const dateCompare = new Date(payloadDate[0], payloadDate[1] - 1, payloadDate[2], 0, 0, 0, 0);
    const limitDate = new Date();
    limitDate.setHours(0, 0, 0, 0);
    limitDate.setDate(limitDate.getDate() + 2);

    if (dateCompare >= limitDate) {
      return true;
    } else {
      return false;
    }
  }

  filterTable(row: any, filter: any) {
    if (filter.from === '' || filter.to === '') return true;
    if (row.date >= filter.from && row.date <= filter.to) {
      return true;
    }

    return false;
  }
}
